import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';
import { TranslateService} from 'ng2-translate';
import {Header} from './bean';
import { Locale, Photo } from './bean';

import {PhotoService} from './service.photo';

declare var openPhotoSwipe: any;

@Injectable()
export class CommonService {
	constructor(
		private http: Http,
		private photoService: PhotoService,
		private translateService: TranslateService
	){

		this.locales[0] = new Locale('English', 'en');
		this.locales[1] = new Locale('Simplified Chinese', 'cn');
//		this.translateService.use('cn');
// let response = this.translateService.instant('Login');
// console.log(response);
// console.log(this.translateService.currentLang)
// 		console.log(this.translateService.get('Login'));

		let lang = localStorage.getItem('language');
		this.changeCurrentLocaleByLanguage(lang);
		//this.currentLocale = JSON.parse(localStorage.getItem('currentLocale'));
		if(this.currentLocale == null){
			this.changeCurrentLocale(this.locales[0]);
		}
		this.translateService.use(this.currentLocale.language);

	}
	public frnpath :string = '';
	public apipath :string = '';
	private locales: Array<Locale> = new Array<Locale>();
	public currentLocale: Locale;

	private changeCurrentLocale(locale: Locale): void{
		this.currentLocale = locale;
		this.translateService.use(locale.language);
		//localStorage.setItem('currentLocale', JSON.stringify(this.currentLocale));

		localStorage.setItem("language", this.currentLocale.language);

	}
	public changeCurrentLocaleByLanguage(lang: string) : void{
		for(let i = 0; i < this.locales.length; i++){
			let l : Locale = this.locales[i];
			if(l.getLanguage() == lang){
				this.changeCurrentLocale(l);
				return;
			}
		}
	}

	public backToReferer: string = null;
	public async getBackToReferer(){
		await this.apiReferer()
		.then((header) =>{
			console.log('api' + header.referer);
			this.backToReferer = header.referer;
		})
		;

	}
	public isAuthencatedIp(): Promise<Boolean>{
		return this.http.get(this.apipath + "/rest/photo/isAuthenticatedIp")
		.toPromise()
		.then(function(resp){
			return resp.json() as Boolean;
		})
		.catch((error) => {
		});

	}
	private apiReferer():Promise<Header>{
		return this.http.get(this.apipath + "/rest/photo/getReferer")
		.toPromise()
		.then(function(header){
			return header.json() as Header;
		})
		.catch((error) => {
		});

	}
	myOpenPhotoSwipe(idx: number): void{
		let location = this.photoService.result[idx].location.replace(".", "_")
		.replace(".jpg", "");
		this.http.get(this.apipath + "/rest/photo/log/openPhoto/" +
			location
		)
		.toPromise()
		.then(function(header){
		})
		.catch((error) => {
		});

// 		if(this.right){
// 			document.addEventListener('contextmenu', this.removeRightClick);
// 			this.right = false;
// 		}
// 		else{
// 			document.removeEventListener('contextmenu', this.removeRightClick);
// 			this.right = true;
// 		}
		var items = new Array();
		for(let i = 0; i < this.photoService.result.length; i++){
			let p: Photo = this.photoService.result[i];
			// var height, width: number;
			// if(p.description ==null || p.description.trim() == ''){
			// 	height = p.height;
			// 	width = p.width;
			// }
			// else{
			// 	height = screen.availHeight - 100;
			// 	width = p.width * (height) / p.height;
			// }
//			console.log(p);
			items.push(
				{
//					src: 'http://localhost/egypt/zoom/large/' + p.location,
//					title: 'p.description',
					//title: p.engDescription,
					title: p.engDescription + "<br />" + p.vol + ",Plate " + p.page,
					src: this.apipath + '/zoom/large/' + p.location,
					photo: p,
//					buyFunc: this.showBuyForm,
//					y : 0,
					w: p.width,
					h: p.height
				}
			);
		}
	// 	var items = [
	// 		{
	// //	        src: 'zoom/small/A0001/AP_Vol.1_PA01.jpg',
	// 			src: 'http://localhost/egypt/zoom/small/A0001/AP_Vol.1_PA01.jpg',
	// //	src: 'https://farm2.staticflickr.com/1043/5186867718_06b2e9e551_b.jpg',
	// 			w: 600,
	// 			h: 400
	// 		},
	// 		{
	// 			src: 'http://localhost/egypt/zoom/large/A0001/AP_Vol.1_PA01.jpg',
	// //	        src: 'zoom/large/A0001/AP_Vol.1_PA01.jpg',
	// //	src: 'https://farm2.staticflickr.com/1043/5186867718_06b2e9e551_b.jpg',
	// 			w: 1200,
	// 			h: 900
	// 		}
	// 	];
		openPhotoSwipe(idx, items
//			, 'https://www.hinet.net'
			,this.backToReferer
		);

		// for (var i = 0; i < document.querySelectorAll('img.pswp__img').length; i++){
		// 	let pswpElement = document.querySelectorAll('img.pswp__img')[i];
		// 	pswpElement.addEventListener('contextmenu', function(e){
		// 		e.preventDefault();
		// 	},
		// 	false);
	
		// }

	}


}



// WEBPACK FOOTER //
// ./src/app/service.common.ts